import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';

var CityGroup = function CityGroup(props) {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var groups = props.groups,
      _props$activedIndex = props.activedIndex,
      current = _props$activedIndex === void 0 ? 0 : _props$activedIndex,
      changeIndex = props.changeIndex;
  var cityPickerPrefixCls = getPrefixCls(prefixCls, 'city-picker');
  var containerCls = classNames("".concat(cityPickerPrefixCls, "-group-container"));

  var handleClick = function handleClick(groupIndex) {
    changeIndex && changeIndex(groupIndex);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: containerCls
  }, _mapInstanceProperty(groups).call(groups, function (item, index) {
    var _context;

    var itemCls = classNames("".concat(cityPickerPrefixCls, "-group-item"), {
      active: current === index,
      last: index === groups.length - 1
    });

    var handleTitleClick = function handleTitleClick() {
      handleClick(index);
    };

    return /*#__PURE__*/React.createElement("div", {
      className: itemCls,
      title: item,
      key: _concatInstanceProperty(_context = "".concat(item, "_")).call(_context, index),
      onClick: handleTitleClick
    }, item);
  }));
};

export default CityGroup;